import React from 'react';
import PropTypes from 'prop-types';
import Link from './shared/Link';
import fabric from '../../../common/fabric';
import utils from '../../../common/utils';

const PathGroup = props => {
  const { params, matrixGroup, style, hyperlink, globalScale } = props;
  const { shadow } = params;
  const [svgRendered, setSvgRendered] = React.useState(null);

  const groupMatrix = matrixGroup
    ? fabric.util.multiplyTransformMatrices(
        matrixGroup,
        params.ludus.transformMatrix,
      )
    : params.ludus.transformMatrix;

  const transformMatrix = fabric.util.multiplyTransformMatrices(
    [globalScale, 0, 0, globalScale, 0, 0],
    groupMatrix,
  );

  React.useEffect(() => {
    fabric.util.enlivenObjects([params], items => {
      items.forEach(object => {
        // reset transform applied by CSS
        // object._removeTransformMatrix();

        object.set({
          angle: 0,
          left: 0,
          top: 0,
          scaleX: 1,
          scaleY: 1,
          skewX: 0,
          skewY: 0,
          shadow: null,
        });
        const _svgRendered = `<svg width="${params.width}" 
          height="${params.height}" 
          viewBox="0 0 ${params.width} ${params.height}" 
          fill="none" xmlns="http://www.w3.org/2000/svg">${object.toSVG()}</svg>`;
        setSvgRendered(_svgRendered);
      });
    });
  }, [props.params]);

  if (!svgRendered) {
    return null;
  }

  const blockStyles = {
    ...style,
    position: 'absolute',
    left: 0,
    top: 0,
    width: params.width,
    height: params.height,
    transformOrigin: 'center',
    transform: `translate(-50%, -50%) matrix(${transformMatrix})`,
    opacity: props.groupOpacity,
    overflow: 'visible',
    backgroundColor: 'transparent',
    mixBlendMode:
      props.params.globalCompositeOperation === 'source-over'
        ? 'normal'
        : props.params.globalCompositeOperation,
  };
  return (
    <div
      style={{
        transform: shadow ? 'translateZ(0px)' : 'none',
        filter: shadow
          ? utils.getDropShadowCSSFilterFromFabricShadow(shadow, 0, globalScale)
          : 'none',
      }}
    >
      <Link
        className="path-group"
        hyperlink={hyperlink}
        style={blockStyles}
        dangerouslySetInnerHTML={{ __html: svgRendered }}
      />
    </div>
  );
  // }
};

PathGroup.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  groupOpacity: PropTypes.number.isRequired,
  hyperlink: PropTypes.string,
  matrixGroup: PropTypes.arrayOf(PropTypes.number),
  globalScale: PropTypes.number.isRequired,
};
PathGroup.defaultProps = {
  hyperlink: null,
  matrixGroup: null,
};

export default PathGroup;
